import React from "react";

const AdminFooter = () => (
    <footer className="main-footer d-flex p-2 px-3 bg-white border-top">
        <span className="copyright ml-auto my-auto mr-2">Copyright © 2019 Easy Card </span>
    </footer>
);

export default AdminFooter;
